import { useCallback } from 'react';
import { logError } from '../utils/errorLogging';
import { useToast } from '../context/ToastContext';

interface ErrorHandlerOptions {
  showToast?: boolean;
  toastMessage?: string;
  rethrow?: boolean;
}

export const useErrorHandler = (component: string) => {
  const { showToast } = useToast();

  const handleError = useCallback(async (
    error: unknown,
    additionalContext?: Record<string, unknown>,
    options: ErrorHandlerOptions = {}
  ) => {
    const {
      showToast: shouldShowToast = true,
      toastMessage = 'An error occurred',
      rethrow = false
    } = options;

    await logError(error, component, additionalContext);

    if (shouldShowToast) {
      showToast(toastMessage, 'error');
    }

    if (rethrow) {
      throw error;
    }
  }, [component, showToast]);

  return handleError;
}; 